import React from 'react';
import linkTo from 'linkTo';
import Box from 'libs/core-components/Box/Box';
import { SolidAnchorButton } from 'libs/core-components/SolidButton/SolidAnchorButton/SolidAnchorButton';
import { Layout } from './common/Layout';

function Masquerading() {
    return (
        <Layout title="Masquerading" heading="Masquerading">
            <Box>Login is unavailable while masquerading.</Box>

            <SolidAnchorButton href={linkTo.logout()} variant="primary" width="fill">
                Log out
            </SolidAnchorButton>
        </Layout>
    );
}

export default Masquerading;
